import { ArrowLeft, Home2 } from 'iconsax-react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { Button } from '@/components/ui/button'
import { weCheckPalette } from '@/utils/palette/weCheckPalette'

interface WeScreenHeaderProps {
  customButton?: React.ReactNode
  disabled?: boolean
  useContinueButton?: boolean
  onClickNext?: (key: any) => void
  useSkipButton?: boolean
  onClickSkipButton?: (key: any) => void
  isLoading?: boolean
  title?: string
  useBackButton?: boolean
  onClickBack?: () => void
  useHomeIcon?: boolean
}

export const WeScreenHeader: React.FC<WeScreenHeaderProps> = ({
  customButton,
  onClickNext,
  disabled,
  useContinueButton = true,
  isLoading,
  title,
  useBackButton = true,
  onClickBack,
  useHomeIcon = false,
  useSkipButton,
  onClickSkipButton,
}) => {
  const navigate = useNavigate()
  const { t } = useTranslation()

  const goBack = () => {
    navigate(-1)
  }

  const showLeftButton = useHomeIcon || useBackButton

  return (
    <div className="flex justify-between items-center bg-baseColorHighlight h-14 p-4 max-md:p-2">
      {showLeftButton && (
        <button
          type="button"
          onClick={onClickBack ? onClickBack : goBack}
          aria-label={t(
            useHomeIcon ? 'dashboard.common.goHome' : 'dashboard.common.goBack',
          )}
          className="flex items-center gap-2 text-neutralColor"
        >
          {useHomeIcon ? (
            <Home2 size="20" color={weCheckPalette.neutralColor} />
          ) : (
            <ArrowLeft size="20" color={weCheckPalette.neutralColor} />
          )}
        </button>
      )}

      {title && (
        <div
          key={`title-${title}`}
          className={`flex ${useBackButton && 'justify-start flex-1 ml-4'}`}
        >
          <h1 className="text-[22px] font-medium text-neutralColor">{title}</h1>
        </div>
      )}

      <div className="flex flex-row gap-4">
        {customButton && customButton}
        {useSkipButton && (
          <Button
            variant="ghost"
            role="button"
            isLoading={isLoading}
            onClick={onClickSkipButton}
          >
            <p className="text-primaryColor text-base font-medium tracking-wide">
              {t('dashboard.newSearch.common.skip')}
            </p>
          </Button>
        )}
        {useContinueButton && (
          <Button
            variant="primary"
            type={onClickNext ? 'button' : 'submit'}
            role="button"
            disabled={disabled}
            isLoading={isLoading}
            onClick={onClickNext}
          >
            <p className="text-base font-medium tracking-wide">
              {t('dashboard.newSearch.common.continue')}
            </p>
          </Button>
        )}
      </div>
    </div>
  )
}
